import styled from "styled-components";
import { CenterFlexRow } from "styles/layout";
import { Select } from "styles/elements";
import { Theme } from "theme";

export const MatchContainer = styled(CenterFlexRow)`
  font-weight: bold;
`;

export const MatchTeamsContainer = styled(CenterFlexRow)`
  padding: 0 50px 0 0;

  @media (max-width: 700px) {
    padding: 0;
  }
`;

export const MatchTime = styled.div`
  padding: 25px;
  font-size: 11pt;
  width: 50px;

  @media (max-width: 700px) {
    display: none;
  }
`;

export const MatchTeamContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 145px;

  @media (max-width: 700px) {
    width: 130px;
  }
`;

export const VsSeperator = styled.div`
  padding: 0 12px;
  font-weight: 500;

  @media (max-width: 600px) {
    font-size: 11pt;
    padding: 0 8px;
  }
`;

export const TeamSelector = styled("button")<{ selected: boolean }>`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 3px;
  border: 3px transparent solid;
  border-radius: 8px;

  ${({ selected }) =>
    selected && `border-color: ${Theme.panelSelectionForeground}`}
`;

export const OrgLogoContainer = styled.div`
  width: 75px;
  height: 65px;

  @media (max-width: 600px) {
    width: 60px;
    height: 50px;
  }
`;

export const OrgName = styled.span`
  font-weight: 500;
  font-size: 11.5pt;
  padding: 6px 0 0 0;

  @media (max-width: 600px) {
    font-size: 11pt;
  }
`;

export const PlayerNames = styled.span`
  font-size: 9.5pt;
`;

export const TeamRecordContainer = styled.div`
  color: gray;
`;

export const DriverPicksContainer = styled(CenterFlexRow)`
  margin: 10px 0;
  column-gap: 40px;
  row-gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 700px) {
    column-gap: 10px;
  }
`;

export const DriverSelect = styled(Select)`
  width: 150px;

  @media (max-width: 700px) {
    width: 120px;
  }
`;
